import React from 'react'
import {animateScroll as scroll} from 'react-scroll'


const Navbar = () => {

    const toggleHome=()=>{
        scroll.scrollToBottom();
    }
   

    return (

        <nav className="nav">
                <div className="nav_heading">
                    <h2>Mynfo</h2>
                </div>
                <div className="nav_buttons">
                    <div className="nav_button">Home</div>
                    <div onClick={toggleHome} className="nav_button">About</div>
                </div>
        </nav>

    )
}

export default Navbar
